import { z } from "zod";
import { Id, NonEmpty } from "../base";
import { TimestampSchema } from "../epoch";
export const XAccountSchema = z.object({
    userId: Id,
    username: NonEmpty,
    name: z.string().optional(),
    profileImageUrl: z.string().nullable().optional(),
    connectedAt: TimestampSchema,
    updatedAt: TimestampSchema.optional(),
});
